import '@fontsource/noto-sans-thaana/400.css';
import '@fontsource/noto-sans-thaana/500.css';
import '@fontsource/noto-sans-thaana/700.css';
import 'material-symbols/rounded.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
